"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FacilityDashboardTitle = FacilityDashboardTitle;
var jsx_runtime_1 = require("react/jsx-runtime");
var text_component_1 = require("../../ui/text-component");
function FacilityDashboardTitle() {
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex flex-col gap-1", children: [(0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "2xlarge", weight: "bold", color: "dark-gray-1", label: "Facility Dashboard" }), (0, jsx_runtime_1.jsx)(text_component_1.TextComponent, { size: "small", color: "medium-gray", label: "Live and historical readings from the devices in this facility." })] }));
}
